import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { select, Store } from '@ngxs/store';
import { UiPillStatusEnum } from 'src/app/shared/enums/ui-pill-status.enum';
import { ProductStatus } from 'src/app/storage-user/enums/product-status.enum';
import { TenantUserAccessState } from 'src/app/tenant-selector/state/tenant-user-access.state';

import { TranslateService } from '@ngx-translate/core';
import { ModuleName } from 'src/app/shared/enums/enums';
import { IStock } from 'src/app/shared/models/stock.model';
import { AddToStockModalComponent } from 'src/app/shared/stock-module/add-to-stock-modal/add-to-stock-modal.component';
import { UseStockModalComponent } from 'src/app/shared/stock-module/use-stock-modal/use-stock-modal.component';
import { ProductAction } from 'src/app/storage-user/enums/product-action.enum';
import {
  TransferProductModalComponent,
  TransferProductModalData,
} from 'src/app/storage-user/modals/transfer-product-modal/transfer-product-modal.component';
import { mapStock } from 'src/app/storage-user/models/use-product.model';
import {
  AddToStock,
  TransferProduct,
  UseProduct,
} from 'src/app/storage-user/state/product.actions';
import { Privileges } from 'src/app/core/privileges/privileges';

@Component({
  selector: 'app-storage-template',
  templateUrl: './storage-template.component.html',
  styleUrls: ['./storage-template.component.scss'],
  standalone: false,
})
export class StorageTemplateComponent implements OnInit {
  @Input() columnName: string;
  @Input() element: any;

  Privileges = Privileges;
  statusColor: string;
  hasMultipleDepartments = select(TenantUserAccessState.hasMultipleDepartments);
  transferDepartmentLabel = '';

  private statusMapper = {
    [ProductStatus.Green]: UiPillStatusEnum.Ok,
    [ProductStatus.Yellow]: UiPillStatusEnum.UnderThreshold,
    [ProductStatus.Red]: UiPillStatusEnum.UnderMinimum,
    [ProductStatus.Blue]: UiPillStatusEnum.ProductInOrder,
  };

  constructor(
    private dialog: MatDialog,
    private store: Store,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.statusColor = this.statusMapper[this.element.status as ProductStatus];
    if (
      this.element.storageProductAction === ProductAction.TransferFromStorage &&
      this.element.destinationDepartment
    ) {
      this.transferDepartmentLabel = `${this.translate.instant('to').toLowerCase()} ${
        this.element.destinationDepartment.name
      }`;
    }
    if (
      this.element.storageProductAction === ProductAction.TransferToStorage &&
      this.element.sourceDepartment
    ) {
      this.transferDepartmentLabel = `${this.translate.instant('from').toLowerCase()} ${
        this.element.sourceDepartment.name
      }`;
    }
  }

  use(): void {
    this.dialog
      .open(UseStockModalComponent, {
        width: '30rem',
        panelClass: 'mobile-sizing-for-mat-dialogs',
        data: {
          id: `${this.element.id}`,
          currentStock: `${this.element.quantity}`,
          module: ModuleName.STORAGE,
        },
      })
      .afterClosed()
      .subscribe((result: IStock) => {
        if (result) {
          const useProduct = mapStock(result);
          this.store.dispatch(new UseProduct(useProduct));
        }
      });
  }

  addToStock(): void {
    this.dialog
      .open(AddToStockModalComponent, {
        width: '45rem',
        panelClass: 'mobile-sizing-for-mat-dialogs',
        data: {
          id: `${this.element.id}`,
          currentStock: `${this.element.quantity}`,
          module: ModuleName.STORAGE,
        },
      })
      .afterClosed()
      .subscribe((result: IStock) => {
        if (result) {
          const useProduct = mapStock(result);
          this.store.dispatch(new AddToStock(useProduct, false));
        }
      });
  }

  openTransferDialog(): void {
    const dialogRef = this.dialog.open(TransferProductModalComponent, {
      panelClass: ['no-padding', 'mobile-sizing-for-mat-dialogs'],
      width: '25rem',
      data: {
        productId: this.element.id,
        productName: this.element.name,
        maxQuantity: this.element.quantity,
      } as TransferProductModalData,
    });

    dialogRef.afterClosed().subscribe((transferRequest) => {
      if (transferRequest) {
        this.store.dispatch(new TransferProduct(transferRequest));
      }
    });
  }
}
